import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=2a3a884e&scoped=true&"
var script = {}
import style0 from "./Spinner.vue?vue&type=style&index=0&id=2a3a884e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3a884e",
  null
  
)

export default component.exports